import {get,post} from "@/utils/request.js"

/* 
	公共页面调用
 */
// 添加收藏
export function addAppCCollect(data){
	return post('/admin/appCCollect/addAppCCollect',data)
}
// 取消收藏===批量
export function delAppCCollect(data){
	return post('/admin/appCCollect/delAppCCollect',data)
}
// 商品详情
export function appCTraderGoodsFindById(data){
	return post('/admin/appCTraderGoods/appCTraderGoodsFindById',data)
}
// 查询二级规格
export function selectAttrTwoBygoodsId(data){
	return post('/admin/appCGoodsAttr/selectAttrTwoBygoodsId',data)
}
// 评论列表
export function newappCCommentsList(data){
	return post('/admin/appCComments/newappCCommentsList',data);
}
// 购物车
export function addAppCCart(data){
	return post('/admin/appCCart/addAppCCart',data)
}
// 报价状态显示
export function findCQuotedPriceHiddenType(data){
	return get('/app/cQuotedPriceHideen/findCQuotedPriceHiddenType',data)
}